import { useHasPermission } from './useHasPermission';
import { useEntitlement } from './useEntitlement';

/**
 * The combined RBAC + Entitlements check: `action` on `module` is only
 * actually usable if the active workgroup's role grants it AND the current
 * package entitles it. This is the seam useHasPermission.ts documented --
 * use it for any new UI gating that should match what the backend's
 * AccessControlService.canAccess will ultimately allow, rather than
 * `useHasPermission` alone (which is RBAC-only and left as-is for existing
 * call sites).
 */
export function useCanAccess(module: string, action: string): boolean {
  return useHasPermission(module, action) && useEntitlement(module, action);
}

export default useCanAccess;
